import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';

export const CategoryCard = ({ category }) => {
  const IconComponent = Icons[category.icon_name] || Icons.Tag;

  return (
    <Link to={`/deals?category=${category.id}`} data-testid="category-card">
      <Card className="hover:shadow-lg transition-all duration-300 hover:-translate-y-1 cursor-pointer group">
        <CardContent className="p-6 flex flex-col items-center text-center space-y-3">
          <div className="w-16 h-16 bg-gradient-to-br from-emerald-100 to-teal-100 rounded-full flex items-center justify-center group-hover:from-emerald-200 group-hover:to-teal-200 transition-colors">
            <IconComponent className="w-8 h-8 text-emerald-600" />
          </div>
          <div>
            <h3 className="font-semibold text-lg" data-testid="category-name">{category.name}</h3>
            <p className="text-sm text-gray-600 mt-1" data-testid="deal-count">{category.deal_count} deals</p>
          </div>
        </CardContent>
      </Card>
    </Link>
  );
};
